import { Box, Button, Paper, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

export function NotFound() {
  return (
    <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '100dvh', p: 2 }}>
      <Paper sx={{ p: 4, maxWidth: 380, textAlign: 'center' }}>
        <Typography variant="h2" sx={{ mb: 1 }}>
          Nothing here
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2.5 }}>
          The link may be old, or it may have been typed slightly wrong.
        </Typography>
        <Button component={RouterLink} to="/" variant="contained">
          Go to your campaigns
        </Button>
      </Paper>
    </Box>
  )
}
